function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.0535 0C15.2893 0 0 15.1882 0 34C0 52.7347 15.2893 68 34.0535 68C52.8948 68 68.1069 52.7347 68.1069 34C68.1069 15.1882 52.8948 0 34.0535 0ZM22.5479 41.3243L21.3124 38.2404H15.5982L14.3627 41.3243H10.8106L17.1426 26.6757H19.8452L26.1771 41.3243H22.5479ZM40.4626 41.3243H37.2194V35.0023H30.8875V41.3243H27.6443V26.6757H30.8875V32.1497H37.1422V26.6757H40.3854V41.3243H40.4626ZM53.667 41.3243L52.4315 38.2404H46.7173L45.4818 41.3243H41.9298L48.2617 26.6757H50.9644L57.3735 41.3243H53.667ZM47.7212 35.4649H51.2732L49.4972 30.9161L47.7212 35.4649Z",
  fill: "#215732"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c00c405b.svg";
export { ForwardRef as ReactComponent };